import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Main from 'view/main';

const MainPage = () => {
	return (
		<PageTemplate>
			<Main /> 
		</PageTemplate>
	);
};

export default MainPage;

 